import React, { Component } from 'react';
class GenericNotFound extends Component {
    // constructor(props) {
    //   super(props);
    // }
    
    render() {
      return (
        <span>Could not find that URL on this server</span>
        )
      }
  }
  
  export default GenericNotFound;